module.exports = __webpack_public_path__ + "img/arrowicon.63c52389.svg";